import moment from 'moment';

import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface PatchDocumentsParticipantsCurrentSigningPeriod {
  documentId: string;
  from?: string; // from 은 현재 사용되지않습니다.
  to: string;
  workspaceId: string;
}

/**
 * PATCH 현재 서명 순서 참여자들의 서명 만료일 변경
 *
 * Endpoint is created in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#119d9ec550194e43973981c7d4b97336
 */
// eslint-disable-next-line import/prefer-default-export
export function patchDocumentsParticipantsCurrentSigningPeriod({
  documentId,
  to,
  workspaceId,
}: PatchDocumentsParticipantsCurrentSigningPeriod) {
  return requestApi({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/current/signing-period`
    ),
    method: 'PATCH',
    data: {
      to: moment(to).format(),
    },
    credentials: true,
  });
}
